import styled from 'styled-components';

export const NavBar = styled.nav`
  background: #011a28;
  color: #fff;
  width: 9rem;
  height: 100vh;
  position: fixed;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  top: 0;
  left: 0;
  z-index: 2;

  .logo-div {
    width: 80%;
    height: 2rem;
    margin: 2.5rem 0;
    text-align: center;
    font-size: 2rem;
    a {
      text-decoration: none;
      color: #b4cfd3;
      text-shadow: 0 0 1px #ffffff, 0 0 2px #ffffff, 0 0 4px #0ba9ca,
        0 0 2px #0ba9ca, 0 0 4px #0ba9ca, 0 0 12px #0ba9ca;
    }
  }

  .nav-list {
    border-top: 1.5px solid #023047;
    border-bottom: 1.5px solid #023047;
    border-right: none;
    width: 100%;
    display: flex;
    flex-direction: column;

    .nav-item {
      border-top: 2px solid #023047;
      border-bottom: 2px solid #023047;
      list-style: none;
      a {
        padding: 1rem;
        display: block;
        text-align: center;
        text-decoration: none;
        color: #8d8d8d;
        font-weight: normal;

        &:hover {
          color: #3bcfe3;
        }
      }
    }
  }

  .contact-icons {
    width: 100%;
    padding: 0 0.5rem;
    display: flex;
    justify-content: space-around;

    .icon-item {
      width: 1.2rem;
      height: 1.2rem;
      list-style: none;
      filter: invert(57%) sepia(7%) saturate(8%) hue-rotate(131deg)
        brightness(96%) contrast(90%);
      &:hover {
        filter: invert(68%) sepia(73%) saturate(411%) hue-rotate(138deg)
          brightness(91%) contrast(95%);
      }
    }
  }

  button {
    color: #3bcfe3;
    font-size: 13px;
    font-weight: 400;
    letter-spacing: 4px;
    font-family: sans-serif;
    text-decoration: none;
    padding: 10px 18px;
    border: 1px solid #3bcfe3;
    margin-bottom: 3rem;
    background-color: transparent;
    float: left;
    white-space: nowrap;

    a {
      color: #3bcfe3;
      &:hover {
        color: #333;
      }
    }

    &:hover a {
      color: #333;
    }
  }

  @media (max-width: 900px) {
    display: none;
  }
`;
